import { render, staticRenderFns } from "./updateStatus.vue?vue&type=template&id=45fb2a50&scoped=true&"
import script from "./updateStatus.vue?vue&type=script&lang=js&"
export * from "./updateStatus.vue?vue&type=script&lang=js&"
import style0 from "./updateStatus.vue?vue&type=style&index=0&id=45fb2a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb2a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDialog,VIcon,VSelect,VTextarea})
